import { PreLanding } from '$shared/components';
import { useCurrentLang, useTranslator } from '$hooks';
import './ModelsLanding.sass';
import { useEffect } from 'react';
import { statReachGoal } from '$utils';

export const ModelsLandingV2 = () => {
  const t = useTranslator();
  const currentLang = useCurrentLang();
  const isRU = currentLang.key === 'ru';

  useEffect(() => {
    statReachGoal('pre_lang_open_2');
  }, []);

  return (
    <PreLanding
      className="ModelsLanding"
      content={[
        {
          mainContent: (
            <div className="ModelsLanding__content__header">
              {t('models_landing_v2_item_1_title')}
            </div>
          ),
          buttons: [
            {
              text: t('models_landing_v2_item_1_button_1'),
              mode: 'inverse',
            },
            {
              text: t('models_landing_v2_item_1_button_2'),
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {isRU ? (
                  <>
                    {t('models_landing_v2_item_2_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_v2_item_2_title_body')}
                    </span>{' '}
                    {t('models_landing_v2_item_2_title_tail')}
                  </>
                ) : (
                  <>
                    {t('models_landing_v2_item_2_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_v2_item_2_title_tail')}
                    </span>
                  </>
                )}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_v2_item_2_caption')}
              </div>
            </>
          ),
          buttons: [
            {
              text: t('models_landing_v2_item_2_button_1'),
              mode: 'inverse',
            },
            {
              text: t('models_landing_v2_item_2_button_2'),
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {isRU ? (
                  <>
                    {t('models_landing_v2_item_3_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_v2_item_3_title_body_1')}
                    </span>{' '}
                    {t('models_landing_v2_item_3_title_body_2')}
                    <br />
                    {t('models_landing_v2_item_3_title_tail')}
                  </>
                ) : (
                  <>
                    {t('models_landing_v2_item_3_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_v2_item_3_title_body')}
                    </span>
                    .<br />
                    {t('models_landing_v2_item_3_title_tail')}
                  </>
                )}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_v2_item_3_caption')}
              </div>
            </>
          ),
          buttons: [
            {
              text: `${t('models_landing_v2_item_3_button_1')}`,
              mode: 'inverse',
            },
            {
              text: `${t('models_landing_v2_item_3_button_2')}`,
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {t('models_landing_v2_item_4_title_head')}{' '}
                <span className="ModelsLanding__content__text__highlighted">
                  {t('models_landing_v2_item_4_title_body_1')}
                </span>{' '}
                {t('models_landing_v2_item_4_title_body_2')}{' '}
                <span className="ModelsLanding__content__text__highlighted">
                  {t('models_landing_v2_item_4_title_tail')}
                </span>
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_v2_item_4_caption')}
              </div>
            </>
          ),
          buttons: [
            {
              text: t('models_landing_v2_item_4_button_1'),
              mode: 'inverse',
            },
            {
              text: t('models_landing_v2_item_4_button_2'),
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {isRU ? (
                  <>
                    {t('models_landing_v2_item_5_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_v2_item_5_title_body')}
                    </span>{' '}
                    {t('models_landing_v2_item_5_title_tail')}
                  </>
                ) : (
                  <>
                    {t('models_landing_v2_item_5_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_v2_item_5_title_tail')}
                    </span>
                  </>
                )}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_v2_item_5_caption')}
              </div>
            </>
          ),
          buttons: [
            {
              text: `${t('models_landing_v2_item_5_button_1')}`,
              mode: 'inverse',
            },
            {
              text: `${t('models_landing_v2_item_5_button_2')}`,
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {isRU ? (
                  <>
                    {t('models_landing_v2_item_6_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_v2_item_6_title_tail')}
                    </span>
                  </>
                ) : (
                  <>
                    {t('models_landing_v2_item_6_title_head')}{' '}
                    <span className="ModelsLanding__content__text__highlighted">
                      {t('models_landing_v2_item_6_title_body')}
                    </span>{' '}
                    {t('models_landing_v2_item_6_title_tail')}
                  </>
                )}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_v2_item_6_caption')}
              </div>
            </>
          ),
          buttons: [
            {
              text: `${t('models_landing_v2_item_6_button_1')}`,
              mode: 'inverse',
            },
            {
              text: `${t('models_landing_v2_item_6_button_2')}`,
              mode: 'tertiary',
            },
          ],
        },
        {
          mainContent: (
            <>
              <div className="ModelsLanding__content__title">
                {t('models_landing_v2_item_7_title')}
              </div>
              <div className="ModelsLanding__content__caption">
                {t('models_landing_v2_item_7_caption_head')}{' '}
                <span className="ModelsLanding__content__text__highlighted">
                  {t('models_landing_v2_item_7_caption_body_1')}
                </span>{' '}
                {t('models_landing_v2_item_7_caption_body_2')}{' '}
                <span className="ModelsLanding__content__text__highlighted">
                  {t('models_landing_v2_item_7_caption_tail')}
                </span>
                .
              </div>
            </>
          ),
          buttons: [
            {
              text: `${t('models_landing_v2_item_7_button')}`,
              mode: 'inverse',
            },
          ],
        },
      ]}
    />
  );
};
